import React from 'react';

import { ContractDto } from '../../../services/dtos/contract.dto';
import { Grid, Skeleton, Typography } from '@mui/material';
import Consommation from '../../others/consommation/consommation';

/**
 * Composant comportant les détails d'un contrat
 * @param props contient les loadeur ainsi que les contrats à traiter
 * @constructor
 */
export default function MyConsommationsUi(props: {
    contracts?: ContractDto[];
    loading: boolean;
    isSearching: boolean;
}) {
    // On boucle sur les contrats pour ressortir leurs données
    return (
        <Grid className="containerOnlineProcess" container rowSpacing={3}>
            <Grid item xs={12}>
                <Typography variant="h4">Mes consommations</Typography>
            </Grid>
            {/*Mise en place d'un skeleton le temps du chargement*/}
            {props.loading ? (
                <Grid item xs={12}>
                    <Skeleton variant="rectangular"></Skeleton>
                </Grid>
            ) : (
                // Pour chaque contrat affichage des consommations
                props.contracts?.map(contract => (
                    <Grid key={contract['@id']} item xs={12}>
                        <Consommation contract={contract} />
                    </Grid>
                ))
            )}
        </Grid>
    );
}
